import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.tabbed-gallery';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="gallery-item">
              <img src="${item.background}" alt="${item.alt}" />
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.tabbed-gallery .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: false,
      autoplay: false,
      breakpoints: {
        1200: {
          perPage: 3,
        },
        991: {
          perPage: 4,
        },
        600: {
          perPage: 3,
        },
        400: {
          perPage: 2,
        },
      },
    });

    const galleryMain = item.closest(moduleSelector).querySelector('.gallery-main');

    const updateGalleryMain = () => {
      const activeSlide = slider.Components.Elements.slides[slider.index];
      const activeImage = activeSlide.querySelector('img');
      if (activeImage && galleryMain) {
        galleryMain.innerHTML = `<img src="${activeImage.src}" alt="${activeImage.alt}" />`;
      }
    };

    slider.on('click', (slide) => {
      slider.go(slide.index);
    });

    slider.on('move', updateGalleryMain);

    slider.on('mounted', updateGalleryMain);

    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
